// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__11T31","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1O898","obliqueLine":"membershipbadge_obliqueLine__16E_v"};